import { createContext, Dispatch, SetStateAction } from 'react'

type MapCoreManagerType = {
  // mapRef: any
  //BASE LAYER
  baseLayerSourceName: any
  setBaseLayerSourceName: Dispatch<SetStateAction<any>>
  // GEOLOCATION
  geolocation: any
  setGeolocation: Dispatch<SetStateAction<any>>
  // MAP
  mapInstance: any
  mapRef: any
  view: any
  markingData: any
  queryingMarkingData: boolean
  selectedEntity: any
  setSelectedEntity: any
  //PROPS
  selectionMode: string
  simpleBaseLayerToogleButton: boolean
  searchField: boolean
  markingDataCard: boolean
  navbar: boolean
  goToMyLocation: boolean
  //FUNCTIONS
  _getMarkingData: any
}

const defaultValue = {
  // mapRef: undefined,
  //BASE LAYER
  baseLayerSourceName: 'OSM',
  setBaseLayerSourceName: () => {},
  // GEOLOCATION
  geolocation: {},
  setGeolocation: () => {},
  // MAP
  mapInstance: '',
  mapRef: null,
  view: null,
  markingData: '',
  queryingMarkingData: false,
  selectedEntity: null,
  setSelectedEntity: () => {},
  //PROPS
  selectionMode: 'POINT_AND_CLICK',
  simpleBaseLayerToogleButton: false,
  searchField: true,
  markingDataCard: false,
  navbar: true,
  goToMyLocation: true,
  //FUNCTIONS
  _getMarkingData: () => {},
}

const MapCoreManagerContext = createContext<MapCoreManagerType>(defaultValue)

export default MapCoreManagerContext
